import {
    getCostProviderLoading,
    getCostProviderReject,
    getCostProviderRequest,
    getCostProviderSuccess
} from "../../actions/costProvider/getAll";

export const getCostProvider = (formData) => async (dispatch, getState) => {
    dispatch(getCostProviderLoading());
    try {
        const { data } = await getCostProviderRequest(formData, getState);
        dispatch(getCostProviderSuccess(data))
    } catch (error) {
        dispatch(getCostProviderReject(error))
    }
    return Promise.resolve();
};